import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dialog-content pt-6" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "dialog-content pb-6" }

import { computed, reactive, ref, watch } from 'vue';
import VDialogHeader from './VDialogHeader.vue'
import VStepper from '@/components/VStepper.vue'
import SuccesDialog from './SuccesDialog.vue';
import VParticipantsDropdown from '../VParticipantsDropdown.vue';
import { useDialogStore } from '@/stores/dialogs';
import { useProgramsStore } from '@/stores/programs';
import { useErrors } from '@/utils/use-errors';
import { useTrackersStore } from '@/stores/trackers';
import { name } from '@/utils/name';
import VUserInfo from '../VUserInfo.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddTeamDialog',
  props: {
    team: null
  },
  setup(__props: any) {

const props = __props as { team?: any }


const dialogStore = useDialogStore()
const programsStore = useProgramsStore()
const trackersStore = useTrackersStore()
const step = ref(1)

const values = reactive<any>(props.team? { ...props.team }: {})

const stepBack = () => {
  if (step.value === 1) {
    dialogStore.close()
    return
  }
  step.value--
}

const errors = useErrors(values)
const required = [ [ 'programId', 'name', 'programStageId' ] ]

const stepForward = () => {
  for (let key of (required[step.value-1] || [])) {
    if (!values[key]) {
      errors[key] = "Это обязательное поле"
    }
  }
  if (step.value === 2 && (!values['students'] || values['students'].length === 0)) {
    errors['students'] = "В команде должен быть хотя бы один участник"
  }
  if (Object.keys(errors).length > 0) return
  step.value++

  if (step.value === 2) {
    programsStore.requestStudents(values['programId']) 
  }
  if (step.value === 3) {
    trackersStore.init()
  }
}

const students = computed(() => {
  const programId = values['programId']
  if (!programId) return
  return programsStore.programs.find(program => program.id === programId)?.students
})

const teams = computed(() => {
  const programId = values['programId']
  if (!programId) return
  const arr = programsStore.programs.find(program => program.id === programId)?.teams
  if (!arr) return
  if (props.team) {
    return arr.filter(item => item.id !== props.team.id)
  }
  return arr
})

const participantsWarning = computed(() => {
  if (!values['students'] || !students.value) return ""
  const filtered = students.value.filter((item: any) => {
    return item.teamId && item.teamId !== props.team?.id && values['students'].find((studentId: string) => item.id === studentId)
  })
  
  if (filtered.length > 0) {
    if (filtered.length === 1) {}
    return `${filtered.map((student: any) => name(student)).join(", ")} ${filtered.length === 1? "сменит": "сменят"} свою команду`
  }

  return ""
})

const studentsInTeam = computed(() => {
  const set = new Set(values['students'])
  return students.value?.filter(item => set.has(item.id))
})

watch(() => values['students'], () => {
  if (values['ceoId'] && values['students'] && !values['students'].includes(values['ceoId'])) {
    delete values['ceoId']
  }
}, { deep: true })

const pending = ref(false)
const submit = async () => {
  pending.value = true 
  try {
    if (props.team) {
      await programsStore.editTeam(props.team.id, values['programId'], values)
      dialogStore.close()
    } else {
      await programsStore.addTeam(values['programId'], values)
      dialogStore.open(SuccesDialog, {})
    }
  } catch(e) {
    pending.value = false
  }
}


return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.team)
      ? (_openBlock(), _createBlock(VDialogHeader, { key: 0 }, {
          default: _withCtx(() => [
            _createTextVNode("Редактирование команды «" + _toDisplayString(props.team.name) + "»", 1)
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(VDialogHeader, { key: 1 }, {
          default: _withCtx(() => [
            _createTextVNode("Добавить команду")
          ]),
          _: 1
        })),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(VStepper, {
        modelValue: step.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((step).value = $event)),
        steps: [ 'Программа', 'Участники', 'Сотрудники' ],
        class: "pb-6"
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(_component_v_window, {
      modelValue: step.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((step).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window_item, {
          value: 1,
          class: "px-6 pt-2"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_text_field, {
                modelValue: values['name'],
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((values['name']) = $event)),
                label: "Название команды",
                variant: "outlined",
                "error-messages": _unref(errors)['name']
              }, null, 8, ["modelValue", "error-messages"]),
              _createVNode(_component_v_select, {
                modelValue: values['programId'],
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((values['programId']) = $event)),
                label: "Программа",
                variant: "outlined",
                items: _unref(programsStore).programs,
                "item-value": "id",
                "item-title": "name",
                "error-messages": _unref(errors)['programId']
              }, null, 8, ["modelValue", "items", "error-messages"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_v_select, {
                modelValue: values['programStageId'],
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((values['programStageId']) = $event)),
                label: "Точка старта",
                variant: "outlined",
                items: _unref(programsStore).stages,
                "item-title": "name",
                "item-value": "id",
                "error-messages": _unref(errors)['programStageId']
              }, null, 8, ["modelValue", "items", "error-messages"])
            ]),
            _createVNode(_component_v_checkbox, {
              label: "Указать индивидуальные дедлайны",
              "hide-details": "",
              class: "mt-n4 mb-4",
              disabled: ""
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, {
          value: 2,
          class: "px-6 pt-2"
        }, {
          default: _withCtx(() => [
            _createVNode(VParticipantsDropdown, {
              modelValue: values['students'],
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((values['students']) = $event)),
              label: "Добавление участников",
              items: _unref(students),
              multiple: "",
              search: "",
              teams: _unref(teams),
              messages: _unref(participantsWarning),
              class: "mb-2"
            }, null, 8, ["modelValue", "items", "teams", "messages"]),
            _createVNode(VParticipantsDropdown, {
              modelValue: values['ceoId'],
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((values['ceoId']) = $event)),
              label: "CEO команды",
              items: _unref(studentsInTeam)
            }, null, 8, ["modelValue", "items"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, {
          value: 3,
          class: "px-6 pt-2"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_select, {
                modelValue: values['trackerId'],
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((values['trackerId']) = $event)),
                label: "Трекер",
                variant: "outlined",
                items: Object.values(_unref(trackersStore).trackers).filter(item => !item.isDirector),
                "item-title": "name",
                "item-value": "id"
              }, {
                chip: _withCtx(({ item, props }) => [
                  _createVNode(VUserInfo, {
                    "user-id": item.raw.id
                  }, null, 8, ["user-id"])
                ]),
                item: _withCtx(({ props, item }) => [
                  _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_avatar, {
                        image: item.raw.avatar,
                        color: "grey-lighten-1",
                        size: "32"
                      }, null, 8, ["image"])
                    ]),
                    _: 2
                  }, 1040)
                ]),
                _: 1
              }, 8, ["modelValue", "items"]),
              _createVNode(_component_v_select, {
                modelValue: values['supervisorId'],
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((values['supervisorId']) = $event)),
                label: "Супервайзер",
                variant: "outlined",
                items: Object.values(_unref(trackersStore).trackers).filter(item => item.isSupervisor),
                "item-title": "name",
                "item-value": "id"
              }, {
                chip: _withCtx(({ item, props }) => [
                  _createVNode(VUserInfo, {
                    "user-id": item.raw.id
                  }, null, 8, ["user-id"])
                ]),
                item: _withCtx(({ props, item }) => [
                  _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_avatar, {
                        image: item.raw.avatar,
                        color: "grey-lighten-1",
                        size: "32"
                      }, null, 8, ["image"])
                    ]),
                    _: 2
                  }, 1040)
                ]),
                _: 1
              }, 8, ["modelValue", "items"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_v_btn, {
        color: "primary",
        onClick: stepBack,
        variant: "tonal",
        class: "mr-2"
      }, {
        default: _withCtx(() => [
          (step.value === 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("Отменить")
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode("Назад")
              ], 64))
        ]),
        _: 1
      }),
      (step.value < 3)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            color: "primary",
            onClick: stepForward
          }, {
            default: _withCtx(() => [
              _createTextVNode("Далее")
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_btn, {
            key: 1,
            color: "primary",
            onClick: submit,
            disabled: pending.value
          }, {
            default: _withCtx(() => [
              (props.team)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("Сохранить данные")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("Добавить команду")
                  ], 64))
            ]),
            _: 1
          }, 8, ["disabled"]))
    ])
  ], 64))
}
}

})